module.exports = __webpack_public_path__ + "img/phone-outgoing-success.902fb27b.svg";